import { api } from './api';

export type SsoProvider = 'saml' | 'oidc';

export interface SsoConfig {
  id: string;
  companyId: string;
  provider: SsoProvider;
  displayName: string;
  entryPoint: string;
  identifier: string;
  emailDomain: string | null;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSsoConfigDto {
  provider: SsoProvider;
  displayName: string;
  entryPoint: string;
  identifier: string;
  secret: string;
  emailDomain?: string | null;
}

export interface UpdateSsoConfigDto {
  displayName?: string;
  entryPoint?: string;
  identifier?: string;
  /** Only send when rotating the secret; omit to leave it unchanged. */
  secret?: string;
  emailDomain?: string | null;
  enabled?: boolean;
}

export const ssoApi = {
  async list(companyId: string): Promise<SsoConfig[]> {
    const r = await api.get<SsoConfig[]>(`/api/companies/${companyId}/sso-configs`);
    return r.data;
  },
  async create(companyId: string, dto: CreateSsoConfigDto): Promise<SsoConfig> {
    const r = await api.post<SsoConfig>(`/api/companies/${companyId}/sso-configs`, dto);
    return r.data;
  },
  async update(companyId: string, id: string, dto: UpdateSsoConfigDto): Promise<SsoConfig> {
    const r = await api.patch<SsoConfig>(`/api/companies/${companyId}/sso-configs/${id}`, dto);
    return r.data;
  },
  async remove(companyId: string, id: string): Promise<void> {
    await api.delete(`/api/companies/${companyId}/sso-configs/${id}`);
  },
  async discover(email: string): Promise<{ configId: string; entryPoint: string; displayName: string; provider: SsoProvider } | null> {
    const r = await api.get(`/api/sso/discover`, { params: { email } });
    return r.data;
  },
  loginUrl(configId: string): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/sso/login?config=${encodeURIComponent(configId)}`;
  },
  metadataUrl(): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/sso/saml/metadata`;
  },
};
